
import React from "react";
import PageTop from "../../ui/page-top"; 
import useFetchCategories from "../../lib/hooks/use-fetch-categories"; 
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import { useParams } from "react-router-dom";
import useFetchProductsDetail from "../../lib/hooks/use-fetch-products-detail";
import { ProductDetails } from "../../ui/product-details";

export default  function ProductsDetail() {
    
  let params: any = useParams();
  const {products,loading} = useFetchProductsDetail({ slug: params.url }); 

  console.log("ProductsDetail::",products);
  const {categories} = useFetchCategories(); 
  const user = getCurrentUser();
  return (
    <React.Fragment>
      <PageTop
        page={{
          has_sub: true,
          has_h2: true,
          title: products?.title,
          h2: products?.sub_title,
          sub_title: "Products",
          url: products?.url,
          sub_url: "/products",
          bg_color: "sky",
        }}
      />
      <ProductDetails product={products}   loading={loading} />
    </React.Fragment>
  );
}
